var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperEnvironmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80 -43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.752,112.45A14.029,14.029,0,1,1,56.781,98.421,14.046,14.046,0,0,1,42.752,112.45Zm0-27A12.971,12.971,0,1,0,55.723,98.421,12.986,12.986,0,0,0,42.752,85.45Z",
    transform: "translate(-25.752 -81.421)",
    fill: "#635c7c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72.484 -34.646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.981,9.107H3.963l0-1A2.943,2.943,0,0,0,6.587,6.823a4.965,4.965,0,0,0,.154-5.07,10.474,10.474,0,0,1-2.509,1.41c-1.1.5-2.147.963-2.49,1.705-.771,1.667.486,2.808,1.3,3.339L2.5,9.046C.675,7.859.052,6.141.834,4.449c.5-1.081,1.709-1.624,2.989-2.2A7.728,7.728,0,0,0,6.427.668a.5.5,0,0,1,.749,0A5.062,5.062,0,0,1,8.362,3.846a6.46,6.46,0,0,1-.917,3.49A3.9,3.9,0,0,1,3.981,9.107Z",
    transform: "translate(-0.624 -0.624)",
    fill: "#635c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.815,19.111a8.128,8.128,0,0,1-5.171-14.4l.637.771a7.1,7.1,0,1,0,2.743-1.4l-.251-.968a8.129,8.129,0,1,1,2.042,16Z",
    transform: "translate(-3.859 -2.092)",
    fill: "#635c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.379,14.789H31.25a.5.5,0,0,1-.416-.223l-.6-.906h-.278l-.23.23a.5.5,0,0,1-.354.146H28.239a.5.5,0,0,1-.354-.146L26.15,12.154H23.723a.5.5,0,0,1-.5-.5V10.9A2.008,2.008,0,0,1,25.228,8.9h.546l.606-.606a.5.5,0,0,1,.354-.146h1.675l.606-.606.707.707L28.969,9a.5.5,0,0,1-.354.146H26.941l-.606.606a.5.5,0,0,1-.354.146h-.753A1.007,1.007,0,0,0,24.223,10.9v.253h2.134a.5.5,0,0,1,.354.146l1.735,1.735h.715l.23-.23a.5.5,0,0,1,.354-.146H30.5a.5.5,0,0,1,.416.223l.6.906h.861Z",
    transform: "translate(-14.795 -4.921)",
    fill: "#635c7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.11,28.036H24.981a.5.5,0,0,1-.5-.5V25.109l-.46-.46h-1.3a.5.5,0,0,1-.5-.5V23.02a.5.5,0,0,1,.146-.354L23.5,21.537a.5.5,0,0,1,.354-.146h1.882a.5.5,0,0,1,.354.146l1.882,1.882a.5.5,0,0,1,.146.354v2.258a.5.5,0,0,1-.146.354L26.463,27.89A.5.5,0,0,1,26.11,28.036Zm-.629-1H25.9l1.212-1.212V23.98l-1.589-1.589H24.059l-.836.836v.422h1.005a.5.5,0,0,1,.354.146l.753.753a.5.5,0,0,1,.146.354Z",
    transform: "translate(-14.171 -13.652)",
    fill: "#635c7c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperEnvironmentIcon);
export default __webpack_public_path__ + "static/media/swiper_environment_icon.6f535f00.svg";
export { ForwardRef as ReactComponent };